import Loader from './Loader.component';
import CircularProgress from '../CircularProgress';

Loader.SIZE = CircularProgress.SIZE;
export default Loader;
